import {
  Autocomplete,
  createTheme,
  MultiSelect,
  NativeSelect,
  NumberInput,
  Select,
  Textarea,
  TextInput,
  InputBase,
} from "@mantine/core";
import { DateInput, DatePickerInput } from "@mantine/dates";

import styles from "./styles/theme.module.scss";

const mantineTheme = createTheme({
  defaultRadius: "sm",
  components: {
    Select: Select.extend({
      classNames: {
        option: styles.selectOption,
        label: styles.inputLabel,
        input: styles.input,
        required: styles.required,
      },
    }),
    Autocomplete: Autocomplete.extend({
      classNames: {
        option: styles.selectOption,
      },
    }),
    TextInput: TextInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
      },
    }),
    DateInput: DateInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
        wrapper: styles.inputWrapper,
        root: styles.dateInputRoot,
      },
    }),
    NativeSelect: NativeSelect.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
      },
    }),
    Textarea: Textarea.extend({
      classNames: {
        input: styles.textarea,
        label: styles.inputLabel,
      },
    }),
    InputBase: InputBase.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
      },
    }),
    NumberInput: NumberInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        control: styles.numberInputControl,
        required: styles.required,
      },
    }),
    MultiSelect: MultiSelect.extend({
      classNames: {
        option: styles.selectOption,
        label: styles.inputLabel,
        input: styles.input,
        required: styles.required,
      },
    }),
    DatePickerInput: DatePickerInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
        wrapper: styles.inputWrapper,
        root: styles.dateInputRoot,
        calendarHeader: styles.calendarHeader,
        day: styles.dateInputDay,
      },
    }),
  },
});

export default mantineTheme;
